import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { TopBar } from "./TopBar";
import { BottomNav } from "./BottomNav";
import { ImpersonationBar } from "./ImpersonationBar";
import { useInactivityLogout } from "@/hooks/useInactivityLogout";
import { useAuth } from "@/contexts/AuthContext";

export function AppLayout({ children }: { children: React.ReactNode }) {
  useInactivityLogout();
  const { roles } = useAuth();
  const isStudent = roles.includes("student");

  return (
    <SidebarProvider defaultOpen={isStudent ? true : undefined}>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col">
          <ImpersonationBar />
          <TopBar />
          <main className="flex-1 p-2 sm:p-3 md:p-4 overflow-auto pb-20 md:pb-4">{children}</main>
        </div>
      </div>
      <BottomNav />
    </SidebarProvider>
  );
}
